import React from 'react';
// import FieldService from 'src/components/FieldService';
// import FieldAddress from 'src/components/FieldAddress';
// import FieldEstimate from 'src/components/FieldEstimate';
// import FieldDate, { FieldDateTime, FieldTime } from 'src/components/FieldDate';
import { Field, ErrorMessage, getIn } from 'formik';
import { IonInput, IonTextarea, IonCheckbox, IonLabel } from '@ionic/react';

import './style.scss';

export const BasicInput = ({ type, name, ...rest }) => {
  return (
    <Field
      name={name}
      render={({ field }) => {
        const { onChange, onBlur, ...restField } = field;
        if (type === 'textarea') {
          return (
            <IonTextarea
              // onIonChange fights with Formik
              // https://github.com/ionic-team/ionic/issues/17936
              // onIonChange={onChange}
              onInput={onChange}
              onIonBlur={onBlur}
              {...rest}
              {...restField}
            />
          );
        }
        if (type === 'checkbox') {
          return (
            <IonCheckbox
              onIonChange={({ target }) => {
                return onChange({
                  target: {
                    name: name,
                    value: target.checked
                  }
                });
              }}
              onIonBlur={onBlur}
              checked={field.value}
              {...rest}
              {...restField}
            />
          );
        }
        return (
          <IonInput
            // onIonChange fights with Formik
            // https://github.com/ionic-team/ionic/issues/17936
            // onIonChange={onChange}
            onInput={onChange}
            onIonBlur={onBlur}
            {...rest}
            {...restField}
          />
        );
      }}
    />
  );
};

const FormGroup = ({ className, children, ...rest }) => {
  return (
    <div className={`form-group ${className ? className : ''}`} {...rest}>
      {children}
    </div>
  );
};

const FormControl = ({ className, onChange, onBlur, inputRef, ...rest }) => {
  if (rest.type === 'textarea') {
    return (
      <IonTextarea
        // onIonChange fights with Formik
        // https://github.com/ionic-team/ionic/issues/17936
        // onIonChange={onChange}
        onInput={onChange}
        onIonBlur={onBlur}
        ref={inputRef}
        className={`form-control ${className ? className : ''}`}
        {...rest}
      />
    );
  }
  return (
    <IonInput
      // onIonChange fights with Formik
      // https://github.com/ionic-team/ionic/issues/17936
      // onIonChange={onChange}
      onInput={onChange}
      onIonBlur={onBlur}
      ref={inputRef}
      className={`form-control ${className ? className : ''}`}
      {...rest}
    />
  );
};

const ControlLabel = ({ className, children, ...rest }) => {
  return (
    <IonLabel
      className={`control-label ${className ? className : ''}`}
      {...rest}
    >
      {children}
    </IonLabel>
  );
};

const HelpBlock = ({ children }) => {
  return <div className="help-block small ">{children}</div>;
};

export default class Input extends React.Component {
  render() {
    return (
      <Field
        name={this.props.name}
        render={(validation) => {
          const type = this.props.type || 'text';
          let Input;
          if (
            type === 'text' ||
            type === 'email' ||
            type === 'password' ||
            type === 'search' ||
            type === 'tel' ||
            type === 'url' ||
            type === 'number' ||
            type === 'textarea'
          ) {
            Input = <FormControl {...validation.field} {...this.props} />;
          }
          // } else if (type === 'checkbox') {
          //   Input = (
          //     <div className="checkbox">
          //       <label className="checkbox-label">
          //         <input
          //           type="checkbox"
          //           defaultChecked={validation.field.value}
          //           {...validation.field}
          //           {...this.props}
          //         />
          //         <span>{this.props.placeholder}</span>
          //       </label>
          //     </div>
          //   );
          // } else if (type === 'radio') {
          //   Input = (
          //     <div className="radio">
          //       <label>
          //         <input
          //           type="radio"
          //           defaultChecked={validation.field.value}
          //           {...validation.field}
          //           {...this.props}
          //         />
          //         <span>{this.props.placeholder}</span>
          //       </label>
          //     </div>
          //   );
          // } else if (type === 'select') {
          //   const Options = this.props.options.map((option, i) => (
          //     <option value={option.value} key={i}>
          //       {option.name}
          //     </option>
          //   ));
          //   Input = (
          //     <FormControl
          //       componentClass={type}
          //       {...validation.field}
          //       {...this.props}
          //     >
          //       {Options}
          //     </FormControl>
          //   );
          // } else if (type === 'service') {
          //   Input = <FieldService {...validation.field} {...this.props} />;
          // } else if (type === 'address') {
          //   Input = <FieldAddress {...validation.field} {...this.props} />;
          // } else if (type === 'estimate') {
          //   Input = <FieldEstimate {...validation.field} {...this.props} />;
          // } else if (type === 'datetime') {
          //   Input = <FieldDateTime {...validation.field} {...this.props} />;
          // } else if (type === 'time') {
          //   Input = <FieldTime {...validation.field} {...this.props} />;
          // } else if (type === 'date') {
          //   Input = <FieldDate {...validation.field} {...this.props} />;
          // }
          const error = getIn(validation.form.errors, this.props.name);
          const touch = getIn(validation.form.touched, this.props.name);
          const hasError = error && touch;
          return (
            <FormGroup className={hasError ? 'has-error' : ''}>
              {this.props.label && (
                <ControlLabel>{this.props.label}</ControlLabel>
              )}
              {Input}
              {!this.props.hideError && (
                <ErrorMessage
                  name={this.props.name}
                  render={(msg) =>
                    hasError ? (
                      <HelpBlock className="small">{msg}</HelpBlock>
                    ) : null
                  }
                />
              )}
            </FormGroup>
          );
        }}
      />
    );
  }
}
